import { AbstractModel } from './AbstractModel'

export class RallyRoundButton extends AbstractModel {
    public static readonly classPath = 'rally-round'
    public id = 0
    public name: string|null = null
    public link: string|null = null
    public image: string|null = null
    public rallyRoundId = 0
    public target: string|null = '_self';
    public createdAt: string|null = null;
    public permission = 3
    public sort = 0
}
